import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import VerticalRightOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalRightOutlined";
import AntdIcon from "../components/AntdIcon";
var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalRightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  VerticalRightOutlined.displayName = 'VerticalRightOutlined';
}
export default /*#__PURE__*/React.forwardRef(VerticalRightOutlined);